import React, { useRef, useState } from 'react';

const FileUpload = ({ authToken }) => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const inputRef = useRef(null);

  const handleFileChange = (event) => {
    setErrorMessage('');
    setSuccessMessage('');
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!file) {
      setErrorMessage('Selecteer eerst een CSV-bestand.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploading(true);

      const url = process.env.REACT_APP_BASE_API_URL + 'Menu';

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': authToken,
          // 'Content-Type': 'multipart/form-data' is not required with fetch when using FormData
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'File upload failed');
      }

      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const data = await response.json();
        console.log('File uploaded successfully', data);
      }

      setSuccessMessage('Upload gelukt. De productlijst is bijgewerkt.');
      setFile(null);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setErrorMessage(error.message || 'Upload mislukt. Controleer je bestand en probeer opnieuw.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="page-wrap">
      <section className="admin-card anim-fade-in">
        <div className="header-row">
          <div>
            <h2 className="headline">Upload productlijst</h2>
            <p className="subtle-text">Upload een CSV om producten in bulk te vervangen of bij te werken.</p>
          </div>
          <button type="button" className="btn-muted" onClick={toLogin}>Terug naar dashboard</button>
        </div>

        {errorMessage && <div className="error-banner" role="alert">{errorMessage}</div>}
        {successMessage && <div className="ok-banner" role="status" aria-live="polite">{successMessage}</div>}

        <div className="two-column upload-layout">
          <div className="field-group">
            <label htmlFor="csvUpload">CSV-bestand</label>
            <input
              id="csvUpload"
              ref={inputRef}
              type="file"
              accept=".csv,text/csv"
              onChange={handleFileChange}
              disabled={isUploading}
            />
            <p className="helper-note">Verwacht formaat: ; gescheiden CSV met kolommen in vaste volgorde.</p>

            <div className="list-block">
              <strong>Kolomvolgorde:</strong><br />
              productNumber;productName;categories;price;type;brouwer;outOfStock;description
            </div>

            <div className="row-actions">
              <button type="button" className="btn-soft" onClick={() => window.location.href = './Bierlijst example.csv'}>
                Download voorbeeldbestand
              </button>
            </div>

            {file && (
              <div className="info-banner" role="status">
                Geselecteerd bestand: <strong>{file.name}</strong>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <button type="submit" className="btn-main" disabled={isUploading || !file}>
                {isUploading ? 'Uploading...' : 'Start upload'}
              </button>
            </form>
          </div>

          <div>
            <h3 className="panel-title">Validatieregels</h3>
            <p className="helper-note" style={{ marginBottom: '8px' }}>Verplichte velden:</p>
            <ul className="upload-guide">
              <li>productNumber moet uniek zijn per product.</li>
              <li>productName is de productnaam.</li>
              <li>categories is een comma separated lijst.</li>
              <li>price gebruikt een puntnotatie, bijvoorbeeld 1.50.</li>
              <li>outOfStock moet True of False zijn.</li>
              <li>description mag geen ; of nieuwe lijnen bevatten, gebruik &lt;/br&gt; voor line breaks.</li>
            </ul>

            <p className="helper-note" style={{ marginTop: '12px', marginBottom: '8px' }}>Optionele velden:</p>
            <ul className="upload-guide">
              <li>type is meestal de bierstijl (Blond, Donker, ...).</li>
              <li>brouwer mag leeg gelaten worden.</li>
            </ul>
          </div>
        </div>
      </section>
    </div >
  );
}

function toLogin() {
  window.location.href = '/login'; // Redirect to login page
}

export default FileUpload;